import { Outlet, ScrollRestoration } from 'react-router-dom'

import Header from '@components/Header'
import Footer from '@components/Footer'

export default function AuthLayout() {
  return (
    <>
      <main className=''>
        <Header layout='auth' />
        <div id='content' className='py-8 flex flex-col w-full sm:px-4 md:w-5/6 lg:w-3/4 mx-auto grow'>
          <Outlet />
          <ScrollRestoration />
        </div>
        <Footer />
      </main>
    </>
  )
}
